import { useAppStore } from '@/stores/app.store.ts'
import type { User } from '@/types/model'
import type { LocationQueryRaw, RouteParams, Router } from 'vue-router'

export const setupApp = (data: User) => {
  // ambil data dari app store
  const { user, setUser, setLoaded } = useAppStore()

  // atur data pengguna jika belum ada
  if (user === null) setUser(data)

  // setting done
  setLoaded(true)
}

export const getUrlImage = (from: string, filename: string): string => {
  // constants
  const urlImage: string = import.meta.env.VITE_APP_ROOT_API + '/img/'

  return urlImage + from + '/' + filename
}

export const openNewTab = (
  name: string,
  router: Router,
  params: RouteParams = {},
  query: LocationQueryRaw = {},
) => {
  const routeData = router.resolve({
    name,
    params,
    query,
  })

  window.open(routeData.href, '_blank')
}
